// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__2p1sg","header":"ReportDetails_header__j0OpW","title":"ReportDetails_title__Fouom","left":"ReportDetails_left__1iDsC"};